export default __webpack_public_path__ + "static/media/icon-ticket.82a6a869.svg";